import { Field, Modal, TextField, ActionButton, PasswordField, Autocomplete } from 'components/commons';
import { useApi, useForm, useModal } from 'hooks';
import React, { useMemo } from 'react';
import { initialState as formState } from './users-form.state';
import styles from './users.module.scss';
import { NotifModal } from 'components/modals';
import locale from 'localization';
import { useEffect } from 'react';
import { CarWithLady } from 'images';
import { handleRequest } from 'utils';
import { updateUser, createUser } from 'apis/user.api';
import { prettifyUserRole } from 'utils/pretty.utils';
import UserRole from 'enums/user-role';

const UsersForm = ({ initialState, actionText, create, userId, refreshPage, ...state }) => {
  const { close } = state;
  const notifModal = useModal();
  const form = useMemo(() => {
    return formState(initialState);
  }, [initialState]);

  const { fields, modifyField, submitForm, getFormValues, validateField, clearForm, isFormSubmittable } = useForm({
    initialState: form
  });

  useEffect(() => {
    console.log(fields);
    console.log(initialState);
    if (state.active) {
      clearForm();
    }
    //eslint-disable-next-line
  }, [state.active]);

  const addUserRequest = useApi({
    api: createUser,
    handleOwnError: {
      badrequest: true
    }
  });

  const editUserRequest = useApi({
    api: updateUser,
    handleOwnError: {
      badrequest: true
    },
    params: {
      userId
    }
  });

  const loading = addUserRequest.loading || editUserRequest.loading;

  const submit = async () => {
    const params = getFormValues();

    const apiRequest = create ? addUserRequest : editUserRequest;

    handleRequest(async () => {
      const finalParams = {
        ...params
      };
      await apiRequest.request(finalParams, () => submit());

      close();
      refreshPage();
      notifModal.show({
        image: CarWithLady,
        title: create ? locale.userSuccessRegistered : locale.userSuccessEdited,
        contentHighlight: [<b>{params.firstName}</b>, <b>{params.lastName}</b>],
        content: create ? locale.successfullyRegisteredUser : locale.successfullyChangeInfoOfUser,
        secondary: create
          ? {
              text: locale.registerNewUser,
              onClick: () => {
                state.show({
                  title: locale.addUser,
                  actionText: locale.add,
                  create: true
                });
              }
            }
          : null
      });
    });
  };

  return (
    <div>
      <NotifModal {...notifModal} />
      <Modal close={loading ? false : close} {...state} className={styles.modalContent}>
        <div className={styles.formContent}>
          <div className={styles.content}>
            <Field {...fields.firstName}>
              <TextField {...fields.firstName} onChange={modifyField} onBlur={validateField} />
            </Field>
            <Field {...fields.lastName}>
              <TextField {...fields.lastName} onChange={modifyField} onBlur={validateField} />
            </Field>
            <Field {...fields.username}>
              <TextField {...fields.username} onChange={modifyField} onBlur={validateField} />
            </Field>
            <Field className={styles.status} label="Role">
              <Autocomplete
                name="role"
                value={fields.role.value}
                options={[
                  { label: prettifyUserRole(UserRole.Admin), value: UserRole.Admin },
                  { label: prettifyUserRole(UserRole.Approver), value: UserRole.Approver },
                  { label: prettifyUserRole(UserRole.Maker), value: UserRole.Maker }
                ]}
                onChange={modifyField}
              />
            </Field>

            <Field {...fields.password}>
              <PasswordField {...fields.password} onChange={modifyField} onBlur={validateField} />
            </Field>
          </div>
        </div>
        <ActionButton
          right
          items={[
            {
              onClick: () => {
                state.close();
              },
              disabled: loading,
              text: locale.cancel
            },
            {
              onClick: () => {
                submitForm(submit);
              },
              disabled: !isFormSubmittable,
              loading,
              text: actionText
            }
          ]}
        />
      </Modal>
    </div>
  );
};

export default UsersForm;
